















import { Component, Vue, Prop } from "vue-property-decorator";
import BorderBox from "@/components/UserInfo/BorderBox/BorderBox.vue";
import { goToLogin } from "@/utils/router_helper";
@Component({
  components: { BorderBox }
})
export default class EmptyAccount extends Vue {
  private toLogin() {
    goToLogin();
  }
}
